import React from 'react';
import './App.css';
import Testimonials from './components/Testimonials';
import AboutMe from './components/AboutMe';
import Footer from './components/Footer';
import Header from './components/Header';
import HomeBanner from './components/HomeBanner';
import Contact from './components/Contact';
import Intro from './components/Intro';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// eslint-disable-next-line
const Videos = React.lazy(() => import('./components/Videos'));

function App() {
   return (
      <>
      <main>
         <Header />
         <HomeBanner />
         <Intro />
         <AboutMe />
         <React.Suspense fallback={<div>Loading Videos...</div>}>
            <Videos/>
         </React.Suspense>
         <Testimonials />
         <GoogleReCaptchaProvider reCaptchaKey="6LcNPbkrAAAAAFRvipKF9VyBeXK8pQ6Hv86W2Evl">
            <Contact />
         </GoogleReCaptchaProvider>
         <Footer />
      </main>
      </>
   );
}

export default App;
